import React from "react";
import "../styles/Timeline.css";

// import images
// import htmlimg from '../assets/images/htmlimg.png';
// import javascriptimg from '../assets/images/javascriptimg.png';
// import reactjsimg from '../assets/images/reactjsimg.png';
// import nodejsimg from '../assets/images/nodejsimg.png';
// import expressjsimg from '../assets/images/expressjsimg.png';
// import mongodbimg from '../assets/images/mongodbimg.png';
// import phpimg from '../assets/images/phpimg.png';

const Timeline = () => {
  return (
    <div className="main">
      <h1> JOURNEY </h1>
      <div className="timeline">
        <div className="container left-container">
          <img src="one.webp" alt="day1" className="img-border" />

          <div className="text-box gradient-border">
            <h2 className="day1text"> Day 1 - Kickstart Your Journey </h2>
            <br />

            <small>
              {" "}
              <span className="company"> [ Online ] </span> 30th October 2025{" "}
            </small>

            <p>
              - Bootcamp Overview & What to Expect.
              <br />- Setting up VS Code for seamless development.
              <br />- Introduction to GitHub – your first step into open source.
            </p>

            <span className="left-container-arrow day1arrow"></span>
          </div>
        </div>

        <div className="container right-container">
          <img src="two.webp" alt="day2" className="img-border" />

          <div className="text-box gradient-border">
            <h2 className="day2text"> Day 2 - Design the Web</h2>
            <br />

            <small>
              {" "}
              <span className="company"> [ Online ] </span> 31st October 2025{" "}
            </small>

            <p>
              - Learn the structure of the web with HTML.
              <br />- Style your pages beautifully with CSS. <br />- Hands-on
              exercises and mini challenges.
            </p>

            <span className="right-container-arrow day2arrow"></span>
          </div>
        </div>

        <div className="container left-container">
          <img src="three.webp" alt="day3" className="img-border" />

          <div className="text-box gradient-border">
            <h2 className="day3text"> Day 3 - Make it Alive</h2>
            <br />

            <small>
              {" "}
              <span className="company"> [ Online ] </span> 1st November 2025{" "}
            </small>

            <p>
              - Introduction to JavaScript.
              <br />
              - Learn how to add interactivity to your website.
              <br />- Build your first mini project.
            </p>

            <span className="left-container-arrow day3arrow"></span>
          </div>
        </div>

        <div className="container right-container">
          <img src="four.webp" alt="day4" className="img-border" />

          <div className="text-box gradient-border">
            <h2 className="day4text"> The Challenge Begins </h2>
            <br />

            <small>
              {" "}
              <span className="company"> [ Self-Paced ] </span> To be announced{" "}
            </small>

            <p>
              - Put your skills to the test!
              <br />- Create your own mini project using HTML, CSS, and JS
              during the break.
              <br />- Let your creativity shine bright like the festival lights!
            </p>

            <span className="right-container-arrow day4arrow"></span>
          </div>
        </div>

        <div className="container left-container">
          <img src="five.jpeg" alt="Express JS" className="img-border" />

          <div className="text-box gradient-border">
            <h2 className="day5text">Project Submission Day </h2>
            <br />

            <small>
              {" "}
              <span className="company"> [ Offline ] </span> To be announced{" "}
            </small>

            <p>
              - Submit your project offline after Diwali. <br />- Showcase your
              work and explain your creative approach — it’s your moment to
              stand out!
            </p>

            <span className="left-container-arrow day5arrow"></span>
          </div>
        </div>

        <div className="container right-container">
          <img src="celebration.jpg" alt="Node JS" className="img-border" />

          <div className="text-box gradient-border">
            <h2 className="day6text"> Winners Announcement</h2>
            <br />

            <small>
              {" "}
              <span className="company"> [ Online ] </span> To be announced
            </small>

            <p>
              - Top 3 Winners: Receive goodies/hamper + Excellence Certificate.
              <br />
              - All Participants (who completes the bootcamp ): Will get a
              Participation Certificate.
              <br />- Celebrate your effort, learning, and creativity!
            </p>

            <span className="right-container-arrow day6arrow"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
